module.exports = __webpack_public_path__ + "static/media/venue-1.4bb804b3.jpg";